import { defineComponent as h, ref as i, watchEffect as y, provide as l, onMounted as _, computed as k, createElementBlock as A, openBlock as c, Fragment as E, createBlock as f, createCommentVNode as M, unref as d, mergeProps as S } from "vue";
import { PersonalizationService as b, PageEditorBridge as v, ContentRendererService as B } from "@magnolia/frontend-helpers-base";
import V from "./vue-editor4.js";
import w from "./vue-editor7.js";
const z = /* @__PURE__ */ h({
  name: "EditablePage",
  __name: "EditablePage",
  props: {
    content: {},
    config: {},
    templateAnnotations: {},
    magnoliaContext: {}
  },
  setup(C) {
    const n = C, s = i({}), r = i(), a = i(), m = i();
    y(() => {
      var p, g;
      m.value = n.magnoliaContext;
      const e = JSON.parse(
        ((g = (p = n.magnoliaContext) == null ? void 0 : p.searchParams) == null ? void 0 : g.selectedComponentVariants) || "{}"
      ), { content: t, templateAnnotations: o } = b.getRenderContent(
        n.content,
        n.templateAnnotations,
        e
      );
      a.value = t, o && (r.value = o);
    }), l("templateAnnotations", r), l("config", n.config), l("magnoliaContext", m);
    const x = () => {
      var e, t;
      return a.value && r.value && r.value[(e = a.value) == null ? void 0 : e["@path"]] ? r.value[(t = a.value) == null ? void 0 : t["@path"]] : "";
    };
    _(() => {
      var e;
      (e = n.magnoliaContext) != null && e.isMagnoliaEdit && (v.initialVariantsHandler(
        s.value,
        n.config.useHistoryPushState
      ), v.init(s.value));
    });
    const P = (e) => {
      var t, o;
      return a.value ? w.mgnlRender(
        a.value,
        e,
        (t = n.config) == null ? void 0 : t.componentMappings,
        (o = n.config) == null ? void 0 : o.fallbackComponent
      ) : null;
    }, u = k(() => x());
    return (e, t) => {
      var o;
      return c(), A(E, null, [
        u.value ? (c(), f(d(V), {
          key: 0,
          annotation: u.value,
          "always-render": (o = n.magnoliaContext) == null ? void 0 : o.isMagnolia,
          "should-run-on-frame-ready": !0
        }, null, 8, ["annotation", "always-render"])) : M("", !0),
        (c(), f(P, S({
          key: d(B).buildKey(a.value)
        }, e.$attrs), null, 16))
      ], 64);
    };
  }
});
export {
  z as default
};
//# sourceMappingURL=vue-editor6.js.map
